import { RSAA } from 'redux-api-middleware';

export const ACCOUNTS_IS_FETCHING = 'ACCOUNTS_IS_FETCHING';
export const ACCOUNTS_GET_SUCCESS = 'ACCOUNTS_GET_SUCCESS';
export const ACCOUNTS_GET_ERROR = 'ACCOUNTS_GET_ERROR';
export const ACCOUNTS_ADD_SET_ROLES = 'ACCOUNTS_ADD_SET_ROLES';
export const ACCOUNTS_ADD_GO_BACK = 'ACCOUNTS_ADD_GO_BACK';
export const ACCOUNT_IS_CREATING = 'ACCOUNT_IS_CREATING';
export const ACCOUNT_ADD_SUCCESS = 'ACCOUNTS_ADD_SUCCESS';
export const ACCOUNT_ADD_ERROR = 'ACCOUNTS_ADD_ERROR';
export const ACCOUNTS_RESEND_INVITATION_SUCCESS = 'ACCOUNTS_RESEND_INVITATION_SUCCESS';
export const ACCOUNTS_RESEND_INVITATION_ERROR = 'ACCOUNTS_RESEND_INVITATION_ERROR';
export const ACCOUNTS_SEND_PASSWORD_RESET_SENDING = 'ACCOUNTS_SEND_PASSWORD_RESET_SENDING';
export const ACCOUNTS_SEND_PASSWORD_RESET_SUCCESS = 'ACCOUNTS_SEND_PASSWORD_RESET_SUCCESS';
export const ACCOUNTS_SEND_PASSWORD_RESET_ERROR = 'ACCOUNTS_SEND_PASSWORD_RESET_ERROR';
export const ACCOUNTS_START_ADD_GROUP_OWNER = 'ACCOUNTS_START_ADD_GROUP_OWNER';
export const ACCOUNTS_TRANSFER_ROLE = 'ACCOUNTS_TRANSFER_ROLE';
export const ACCOUNTS_SET_TRANSFER_FROM = 'ACCOUNTS_SET_TRANSFER_FROM';
export const ACCOUNTS_GET_TRANSFER_LIST_SUCCESS = 'ACCOUNTS_GET_TRANSFER_LIST_SUCCESS';
export const ACCOUNTS_GET_TRANSFER_LIST_ERROR = 'ACCOUNTS_GET_TRANSFER_LIST_ERROR';

// Initial State
export const initialState = {
  filters: [
    {
      key: 'status',
      label: 'Status',
      isRadio: true,
      values: [
        { label: 'Active', value: '1' },
        { label: 'Deactivated', value: '2' },
        { label: 'Inactive', value: '3' },
        { label: 'Pending', value: '0' }
      ],
      selectedValue: null
    }
  ],
  searchQuery: null,
  defaultSearchParams: {
    perPage: 10,
    page: 1
  },
  sorting: {
    prop: '',
    direction: ''
  },
  pagination: {
    page: 1,
    total: 0
  },
  isFetching: false,
  items: [],
  isCreating: false,
  create: {
    step: 1,
    isGroupOwner: false,
    roles: [],
    information: {
      givenName: '',
      familyName: '',
      email: '',
      confirmEmail: ''
    }
  },
  transferRole: {
    items: [],
    complete: false,
    to: '',
    from: ''
  },
  error: null,
  resetPasswordSuccess: null
};

// Actions
export const getAccountsList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'collection',
      queryString,
      types: [
        ACCOUNTS_IS_FETCHING,
        {
          type: ACCOUNTS_GET_SUCCESS,
          meta: { ...queryString }
        },
        ACCOUNTS_GET_ERROR
      ]
    }
  };
};

export const getTransferAccountList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'collection',
      queryString,
      types: [
        ACCOUNTS_IS_FETCHING,
        {
          type: ACCOUNTS_GET_TRANSFER_LIST_SUCCESS,
          meta: { ...queryString }
        },
        ACCOUNTS_GET_TRANSFER_LIST_ERROR
      ]
    }
  };
};

export const setAccountRoles = payload => {
  return {
    type: ACCOUNTS_ADD_SET_ROLES,
    payload
  };
};

export const setAccountBack = () => {
  return {
    type: ACCOUNTS_ADD_GO_BACK
  };
};

export const createAccount = data => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'bci:submit',
      body: { ...data, redirectUrl: window.location.origin },
      types: [ACCOUNT_IS_CREATING, ACCOUNT_ADD_SUCCESS, ACCOUNT_ADD_ERROR]
    }
  };
};

// TODO: remove the isFetching: true property from the reducer on ACCOUNT_ADD_SUCCESS
// when createAccountOld is removed.
export const createAccountOld = data => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_USER',
      controlAction: 'bci:submit',
      body: {
        givenName: data.information.givenName,
        familyName: data.information.familyName,
        email: data.information.email,
        roles: data.roles,
        redirectUrl: window.location.origin
      },
      types: [ACCOUNTS_IS_FETCHING, { type: ACCOUNT_ADD_SUCCESS, payload: data.information.email }, ACCOUNT_ADD_ERROR]
    }
  };
};

export const resendInvitation = (data, account) => {
  return {
    [RSAA]: {
      controlKey: 'FROM_INSTANCE',
      controlInstance: account.invitation,
      controlAction: 'bci:submit',
      body: {
        companyName: data.companyName,
        redirectUrl: window.location.origin
      },
      types: ['Invitation Fetching - NA', ACCOUNTS_RESEND_INVITATION_SUCCESS, ACCOUNTS_RESEND_INVITATION_ERROR]
    }
  };
};

export const resetPassword = account => {
  return {
    [RSAA]: {
      controlKey: 'FROM_INSTANCE',
      controlInstance: account.passwordResetRequest,
      controlAction: 'bci:submit',
      types: [
        ACCOUNTS_SEND_PASSWORD_RESET_SENDING,
        ACCOUNTS_SEND_PASSWORD_RESET_SUCCESS,
        ACCOUNTS_SEND_PASSWORD_RESET_ERROR
      ]
    }
  };
};

export const startAddGroupOwner = () => {
  return {
    type: ACCOUNTS_START_ADD_GROUP_OWNER
  };
};

export const transferRole = userId => {
  return {
    type: ACCOUNTS_TRANSFER_ROLE,
    userId
  };
};

export const setTransferFrom = userId => {
  return {
    type: ACCOUNTS_SET_TRANSFER_FROM,
    userId
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNTS_IS_FETCHING:
      return { ...state, isFetching: true, error: null, resetPasswordSuccess: null };

    case ACCOUNTS_GET_SUCCESS:
      let prop, direction;
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        prop = splitted[0];
        if (prop === state.sorting.prop) {
          direction = splitted[1];
        } else {
          direction = 'asc';
        }
      }
      return {
        ...state,
        isFetching: false,
        error: null,
        resetPasswordSuccess: null,
        items: action && action.payload && action.payload.items ? action.payload.items : [],
        searchQuery: action.meta && action.meta.search ? action.meta.search : null,
        filters: [...state.filters].map(e => ({
          ...e,
          selectedValue: action.meta[e.key] ? action.meta[e.key] : null
        })),
        pagination: {
          ...state.pagination,
          page: +action.meta.page,
          total: action && action.payload && action.payload.pageCount ? action.payload.pageCount : 1
        },
        sorting: {
          ...state.sorting,
          prop: prop ? prop : state.sorting.prop,
          direction: direction === 'asc' ? ':desc' : ':asc'
        }
      };

    case ACCOUNTS_GET_ERROR:
    case ACCOUNTS_GET_TRANSFER_LIST_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case ACCOUNTS_ADD_SET_ROLES:
      return {
        ...state,
        create: {
          ...state.create,
          step: state.create.step + 1,
          roles: [...action.payload]
        }
      };

    case ACCOUNTS_ADD_GO_BACK:
      return {
        ...state,
        create: {
          ...state.create,
          step: state.create.step - 1
        }
      };

    case ACCOUNT_IS_CREATING:
      return { ...state, isCreating: true, error: null };

    case ACCOUNT_ADD_SUCCESS:
      return {
        ...state,
        isCreating: false,
        isFetching: false, // TODO: remove with createAccountOld
        error: null,
        create: {
          ...state.create,
          step: state.create.step + 1,
          information: {
            ...state.create.information,
            email: action.payload
          }
        }
      };

    case ACCOUNT_ADD_ERROR:
      return {
        ...state,
        isCreating: false,
        error: action.payload
      };

    case ACCOUNTS_RESEND_INVITATION_SUCCESS:
      return {
        ...state,
        error: null
      };

    case ACCOUNTS_RESEND_INVITATION_ERROR:
      return {
        ...state,
        error: action.payload
      };

    case ACCOUNTS_SEND_PASSWORD_RESET_SENDING:
      return { ...state, isFetching: true, error: null, resetPasswordSuccess: null };

    case ACCOUNTS_SEND_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        error: null,
        resetPasswordSuccess: true
      };

    case ACCOUNTS_SEND_PASSWORD_RESET_ERROR:
      return {
        ...state,
        error: action.payload,
        resetPasswordSuccess: false
      };

    case ACCOUNTS_START_ADD_GROUP_OWNER:
      return {
        ...state,
        create: {
          ...initialState.create,
          isGroupOwner: true,
          step: 2
        }
      };

    case ACCOUNTS_GET_TRANSFER_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        transferRole: {
          ...state.transferRole,
          items: action.payload.items
        }
      };

    case ACCOUNTS_TRANSFER_ROLE:
      return {
        ...state,
        transferRole: {
          ...state.transferRole,
          complete: true,
          to: action.userId
        }
      };

    case ACCOUNTS_SET_TRANSFER_FROM:
      return {
        ...state,
        transferRole: {
          ...state.transferRole,
          from: action.userId
        }
      };

    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        create:
          action.payload && action.payload.state && action.payload.state.skipReset
            ? { ...state.create }
            : { ...initialState.create },
        transferRole: {
          ...initialState.transferRole,
          from: state.transferRole.from
        }
      };

    default:
      return state;
  }
};
